/**
 * 模組頁面代碼 : 1340-UI-06
 * 頁面說明 : 職位資訊新增修改視窗
 * @module web/modules/access-management/components/PositionModal
 */

// ----- import from npm modules -----
import React, { useState, useEffect } from 'react';

// ----- constants -----
const POSITION_NEW = 'new';
const POSITION_EDIT = 'edit';

const RESPONSE_OK = 200;
const TITLE_POSITION_NEW = '新增職位';
const TITLE_POSITION_EDIT = '修改職位';

const PositionModal = React.forwardRef((props, ref) => {
    const { mode, position } = props;
    let modalIcon = mode === POSITION_NEW? '#ico-plus' : '#ico-edit';
    let modalTitleText = mode === POSITION_NEW? TITLE_POSITION_NEW : TITLE_POSITION_EDIT;

    // 初始化state
    const [formValues, setFormValues] = useState({
        modalPositionName: '',
        modalPositionDescription: '',
    });

    const [invalidShow, setInvalidShow] = useState('none');

    // Handle change event
    const handleChange = (event) => {
        setFormValues({
            ...formValues,
            [event.target.name]: event.target.value,
        });
    };

    // 使用useEffect在position改變才更新formValues
    useEffect(() => {
        setFormValues({
            modalPositionName: position? position.positionName : '',
            modalPositionDescription: position? position.positionDescription : '',
        });
    
        setInvalidShow('none');
    }, [position]);

    const handleSubmit = (e) => {
        e.preventDefault();
        e.stopPropagation();
        const form = e.currentTarget;

        if (form.checkValidity() === false) {
            setInvalidShow('block');
            form.classList.add('was-validated');
            return;
        }

        // 建立 FormData 讀取表单的值
        const formData = new FormData(form);

        // 建立角色物件
        const savePosition = {
            positionId: mode === POSITION_NEW? null : position.positionId,
            positionName: formData.get('modalPositionName'),
            positionDescription: formData.get('modalPositionDescription'),
        };

        // 呼叫父層元件的新增或修改角色函式
        if (mode === POSITION_NEW) {
            props.addPosition(savePosition).then((response) => {
                const statusCode = response.payload.code;
                if (statusCode !== RESPONSE_OK) {
                    $(ref.current).modal('hide');
                    props.onErrorHandle(TITLE_POSITION_NEW, response.payload );
                } else {
                    props.fetchPositionSelection();
                    // 调用 fetchPositionList and Hide the modal
                    props.fetchPositionList().then(() => {
                        props.setNeedPositionListLoad(true);
                        $(ref.current).modal('hide');
                    });
                }
            });
        } else if (mode === POSITION_EDIT) {
            props.editPosition(savePosition).then((response) => {
                const statusCode = response.payload.code;
                if (statusCode !== RESPONSE_OK) {
                    $(ref.current).modal('hide');
                    props.onErrorHandle(TITLE_POSITION_EDIT, response.payload );
                } else {
                    // 调用 fetchPositionList and Hide the modal
                    props.fetchPositionList().then(() => {
                        props.setNeedPositionListLoad(true);
                        $(ref.current).modal('hide');
                    });
                }
            });
        }
    }

    return (
        <div ref={ref}
            className="modal fade"
            id="modalPosition"
            data-bs-backdrop="static"
            data-bs-keyboard="false"
            tabIndex="-1"
            aria-labelledby="modalPositionLabel"
            aria-hidden="true"
        >
            <div className="modal-dialog modal-dialog-centered modal-dialog-scrollable">
                <form className="modal__form modal-content needs-validation" id="modalPositionForm" onSubmit={handleSubmit}>
                    <div className="modal-header">
                        <h1 className="modal-title fs-5" id="modalPositionLabel">
                            <div className="modal__title__badge">
                                <svg className="badge__icon" aria-hidden="true">
                                    <use href={modalIcon}></use>
                                </svg>
                            </div>
                            <div className="modal__title__text">{modalTitleText}</div>
                        </h1>
                        <button type="button" className="btn-close btn-cancel" data-bs-dismiss="modal" aria-label="Close"></button>
                    </div>
                    <div className="modal-body">
                        <div className="d-flex flex-column gap-3 px-2">
                            <div className="modal__form__catagory row">
                                <div className="col-3"><div className="modal__form__catagory__lable">職位資訊</div></div>
                                <div className="col-9">
                                    <div className="row">
                                        <div className="col">
                                            <label htmlFor="modalPositionName" className="form-label">職位名稱*</label>
                                            <input
                                                type="text"
                                                className="form-control form-control-sm"
                                                id="modalPositionName"
                                                name="modalPositionName"
                                                value={formValues.modalPositionName}
                                                onChange={handleChange}
                                                required
                                            />
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col">
                                            <label htmlFor="modalPositionDescription" className="form-label">職位說明</label>
                                            <textarea
                                                className="form-control"
                                                id="modalPositionDescription"
                                                name="modalPositionDescription"
                                                value={formValues.modalPositionDescription}
                                                onChange={handleChange}
                                                rows="3"></textarea>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-12">
                                    <div className="alert alert-warning global-invalid-feedback" style={{ display: invalidShow }}></div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="modal-footer">
                        <button type="button" className="btn btn-cancel" data-bs-dismiss="modal">取消</button>
                        <button type="submit" className="btn btn-primary">儲存</button>
                    </div>
                </form>
            </div>
        </div>
    );
});

export default PositionModal;